import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import clsx from 'clsx';
interface TrendBadgeProps {
  trend: number; // percentage, can be negative
  inverse?: boolean; // if true, positive trend is bad (e.g. for burnout)
}
export function TrendBadge({
  trend,
  inverse = false
}: TrendBadgeProps) {
  const isPositive = trend > 0;
  const isNeutral = trend === 0;
  // Determine color logic
  // Standard: Up = Green (Good), Down = Red (Bad)
  // Inverse: Up = Red (Bad), Down = Green (Good)
  let colorClass = 'text-secondary bg-secondary/10';
  let Icon = Minus;
  if (!isNeutral) {
    if (inverse) {
      colorClass = isPositive ? 'text-danger bg-danger/10' : 'text-success bg-success/10';
    } else {
      colorClass = isPositive ? 'text-success bg-success/10' : 'text-danger bg-danger/10';
    }
    Icon = isPositive ? ArrowUpRight : ArrowDownRight;
  }
  return <span className={clsx('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium', colorClass)} data-id="element-148">
      <Icon className="w-3 h-3 mr-1" data-id="element-149" />
      {Math.abs(trend)}%
    </span>;
}